export type CommissionPaymentType = 'payment' | 'reversal' | 'adjustment';
export type CommissionPaymentMethod = 'bank_transfer' | 'check' | 'other';
export type CommissionPaymentPartyType =
  | 'expert_individual'
  | 'expert_organization'
  | 'company';

import type { OrganizationDTO } from './organization.types';

export interface CommissionPaymentDTO {
  id: string;
  company_id: string;
  document_number: string;
  invoice_id: string;
  invoice_number?: string;
  invoice_for?: string;
  payee_type?: CommissionPaymentPartyType;
  payee_expert_id?: string;
  payee_organization_id?: string;
  payee_name?: string;
  invoice_recipient_type?: CommissionPaymentPartyType;
  invoice_recipient_expert_id?: string;
  invoice_recipient_organization_id?: string;
  invoice_recipient_name?: string;
  company_organization_id?: string;
  company_organization_name?: string;
  type: CommissionPaymentType;
  reverses_payment_id?: string;
  amount_minor: number;
  currency: string;
  payment_date: string;
  payment_method: CommissionPaymentMethod;
  payment_reference: string;
  reason?: string;
  notes?: string;
  created_at: string;
  created_by: string;
}

export interface CommissionPaymentListResponseDTO {
  items: CommissionPaymentDTO[];
  total: number;
  page: number;
  limit: number;
}

export interface CommissionPaymentSearchDTO {
  invoice_id?: string;
  type?: CommissionPaymentType;
  payment_method?: CommissionPaymentMethod;
  payee_organization_id?: string;
  invoice_recipient_organization_id?: string;
  date_from?: Date | string;
  date_to?: Date | string;
  page?: number;
  limit?: number;
  sort_by?: string;
  sort_direction?: 'asc' | 'desc';
}

export interface CommissionPaymentListFilters {
  paymentType: CommissionPaymentType | 'all';
  paymentMethod: CommissionPaymentMethod | 'all';
  payeeOrganization: Partial<OrganizationDTO> | null;
  payerOrganization: Partial<OrganizationDTO> | null;
}

export const defaultPaymentListFilters = (): CommissionPaymentListFilters => ({
  paymentType: 'all',
  paymentMethod: 'all',
  payeeOrganization: null,
  payerOrganization: null,
});

export const clonePaymentListFilters = (
  filters: CommissionPaymentListFilters
): CommissionPaymentListFilters => ({
  paymentType: filters.paymentType ?? 'all',
  paymentMethod: filters.paymentMethod ?? 'all',
  payeeOrganization: filters.payeeOrganization ?? null,
  payerOrganization: filters.payerOrganization ?? null,
});

export interface CreateCommissionPaymentDTO {
  invoice_id: string;
  amount_minor: number;
  currency: string;
  payment_date: string;
  payment_method: CommissionPaymentMethod;
  payment_reference: string;
  notes?: string;
}

export interface ReverseCommissionPaymentDTO {
  reason: string;
}

export const PAYMENT_METHOD_LABELS: Record<CommissionPaymentMethod, string> = {
  bank_transfer: 'Bank Transfer',
  check: 'Check',
  other: 'Other',
};

export const PAYMENT_TYPE_LABELS: Record<CommissionPaymentType, string> = {
  payment: 'Payment',
  reversal: 'Reversal',
  adjustment: 'Adjustment',
};
